'use client';
import { jsx } from 'react/jsx-runtime';
import t$1 from 'prop-types';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

let t = {
    xs: t$1.bool,
    sm: t$1.bool,
    md: t$1.bool,
    lg: t$1.bool,
    xl: t$1.bool
}, a = Object.keys(t);
const Hidden = renderWithRef('Hidden', t, (e, r)=>{
    useComponentStylesLoaded('Hidden', SWAN_STYLE_KEY_MAP.hidden);
    let { children: t, xs: m = false, sm: i = false, md: p = false, lg: l = false, xl: c = false } = e, h = new Set();
    return m && h.add('swan-hidden-xs'), i && h.add('swan-hidden-sm'), p && h.add('swan-hidden-md'), l && h.add('swan-hidden-lg'), c && h.add('swan-hidden-xl'), jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: h,
        props: e,
        propKeysToRemove: a,
        children: t
    });
});

export { Hidden };
